/**
 * Simplifies sqrt(n) into the form a√b where b is square-free.
 * Returns [a, b] such that sqrt(n) = a * sqrt(b), with b having no perfect square factors.
 * Special case: sqrt(0) = [0, 1], sqrt(1) = [1, 1].
 */
export function simplifySqrt(n: number): [number, number] {
  if (n === 0) return [0, 1];
  if (n === 1) return [1, 1];

  let squareFactor = 1;
  let remaining = n;

  // Extract all square factors via trial division
  // Check each integer k from 2 up to sqrt(remaining)
  for (let k = 2; k * k <= remaining; k += 1) {
    while (remaining % (k * k) === 0) {
      squareFactor *= k;
      remaining /= k * k;
    }
  }

  return [squareFactor, remaining];
}

/**
 * Formats a radical expression [a, b] as a string.
 * formatRadical(5, 2) → '5√2'
 * formatRadical(7, 1) → '7'
 * formatRadical(1, 3) → '√3'
 */
export function formatRadical(a: number, b: number): string {
  if (b === 1) {
    return String(a);
  }
  if (a === 1) {
    return `√${b}`;
  }
  return `${a}√${b}`;
}
